'use client';

import { createContext, useContext } from 'react';
import {userType} from '@/lib/types'

const UserCtx = createContext<userType | null>(null);
export const useUser = () => useContext(UserCtx);

type Props = {
    user: userType | null;
    children: React.ReactNode;
}
export function UserProvider({user,children,}: Props) {
    return <UserCtx.Provider value={user}>{children}</UserCtx.Provider>;
}
